import { analytics } from 'common/services';
import { isBotUserAgent, isE2ESession, isFeatureEnabled } from 'common/utils';

export const initMixpanel = () => {
  // Don't initialize Mixpanel in E2E test sessions, if bot detected, or if feature is disabled
  if (isE2ESession() || isBotUserAgent() || !isFeatureEnabled('MixpanelEnabled')) {
    return;
  }

  analytics.init(window._env_.MIXPANEL_TOKEN || 'natter', {
    // Same-origin intake (product-events-ingest via CloudFront /mpintake/*). Events reach Mixpanel
    // only from Snowflake, never from the browser.
    api_host: `${window.location.origin}/mpintake`,
    // Clicks, inputs, page views, scrolls and form submits, without any element's text. Page URLs
    // are sent whole, invite codes included, so Mixpanel shows the real pages.
    autocapture: { capture_text_content: false },
    // Keeps the device id off the cookie that every request to our API would carry.
    persistence: 'localStorage',
  });
};
